import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectProviderGames } from '../../state';
import { ProviderGamesProps } from './ProviderGames.types';
import GamesGrid from '../GamesGrid/GamesGrid';

function ProviderGames({ provider }: ProviderGamesProps) {
  const gameIds = useSelector((state) => selectProviderGames(state, provider));

  return (
    <GamesGrid
      gameIds={gameIds}
      loading={!gameIds.length}
      contentContainerStyle={{
        paddingTop: 'space-400',
        paddingBottom: 'safe-area-inset-bottom',
        paddingHorizontal: 'space-600',
      }}
      imageType="square"
    />
  );
}

export default memo(ProviderGames);
